import elementResizeDetectorMaker from 'element-resize-detector';

const observer = elementResizeDetectorMaker()

export default function(Vue, options) {
	Vue.mixin({
		data() {
			return {
				_detectors: []
			}
		},

		methods: {
			// 必须在mounted之后调用
			afterContainerResize(container, callback, options) {
				this.$nextTick(() => {
					var $con,
						listener

					// element
					if (container.getElementsByClassName && container.nodeType == 1) {
						$con = container
					}

					// css-selector
					if (typeof container == "string") {
						$con = document.querySelector(container)
					}

					// default
					if (typeof container == "function") {
						$con = this.$el
						options = callback
						callback = container
					}

					options = options || {}
					var { immediate = false } = options

					if ($con) {
						listener = function(el) {
							callback(el, {
								windowHeight: window.innerHeight,
								windowWidth: window.innerWidth,
							})
						}

						observer.listenTo($con, listener)
						this.$data._detectors.push({
							el: $con,
							listener
						})

						// 立即执行
						if (immediate) {
							listener($con)
						}
					}
				})
			}
		},

		beforeDestroy() {
			this.$data._detectors.forEach(p => observer.removeListener(p.el, p.listener))
		},
	})
}